import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

const BASE_DOMAIN = 'my-digital-lab-assistant.siemens-healthineers.com';
const KNOWN_STAGES = ['dev', 'qa'];

@Injectable({
    providedIn: 'root'
})
export class EmeaRedirectGuard implements CanActivate {
    public canActivate(): boolean {
        const hostname = window.location.hostname;

        let stagePrefix = '';
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            stagePrefix = 'dev.';
        } else {
            for (const stage of KNOWN_STAGES) {
                if (hostname === `${stage}.${BASE_DOMAIN}` || hostname.endsWith(`.${stage}.${BASE_DOMAIN}`)) {
                    stagePrefix = `${stage}.`;
                    break;
                }
            }
        }

        const urlObj = new URL(window.location.href);
        const remainingPath = urlObj.pathname.startsWith('/emea')
            ? urlObj.pathname.slice('/emea'.length).replace(/^\//, '')
            : '';

        const path = remainingPath ? `/${remainingPath}` : '';
        const query = urlObj.search || '';

        window.location.href = `https://${stagePrefix}emea.${BASE_DOMAIN}${path}${query}`;

        return false;
    }
}
